import { PageData, ProfileGroupPage } from 'types/Page';

type ProfilePartial = {
  id: number | string;
  name: string;
  type: number;
  logo?: {
    src: string;
  };
  isGlobal?: boolean;
};

export function pageDataToProfilePartial(
  pageData: PageData | ProfileGroupPage,
): ProfilePartial {
  return {
    id: pageData.id,
    name: pageData.name,
    type: pageData.type,
    logo: pageData.logo ? { src: pageData.logo.src } : undefined,
    isGlobal: pageData.isGlobal ?? false,
  };
}
